import React, {Component, Suspense} from 'react'
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'
import {AuthProvider} from './context/AuthProvider'
import './scss/style.scss'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Portail = React.lazy(() => import('./views/pages/login/Portail'));
const ForcePassword = React.lazy(() => import('./views/pages/ForcePassword'));
const ForgotPassword = React.lazy(() => import('./views/pages/ForgotPassword'));
const RenewPassword = React.lazy(() => import('./views/pages/RenewPassword'));

const OublierMotDePasse = React.lazy(() => import('./views/pages/oublierMotDePasse'));

const AccessWithDefaultPassword = React.lazy(() => import('./views/pages/createPassword/AccessWithDefaultPassword'));
const FirstCreatePassword = React.lazy(() => import('./views/pages/createPassword/FirstCreatePassword'));

const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));


class App extends Component {
  render() {
    return (
      <Router>
        <AuthProvider>
          <Suspense fallback={loading}>
            <Routes>
              <Route exact path="/login" name="Login Page" element={<Login/>}/>
              <Route exact path="/portail" name="Portail Page" element={<Portail/>}/>
              <Route exact path="/register" name="Register Page" element={<Register/>}/>
              <Route exact path="/oubliMotDePasse" name="Oubli Mot DePasse" element={<OublierMotDePasse/>}/>
              <Route exact path="/404" name="Page 404" element={<Page404/>}/>
              <Route exact path="/500" name="Page 500" element={<Page500/>}/>
              <Route exact path="/ForcePassword" name="ForcePassword" element={<ForcePassword/>}/>
              <Route exact path="/ForgotPassword" name="ForgotPassword" element={<ForgotPassword/>}/>
              <Route exact path="/RenewPassword" name="ForgotPassword" element={<RenewPassword/>}/>

              <Route exact path="/AccessWithDefaultPassword" name="ForgotPassword" element={<AccessWithDefaultPassword/>}/>
              <Route exact path="/FirstCreatePassword" name="ForgotPassword" element={<FirstCreatePassword/>}/>

              <Route path="*" name="Home" element={<DefaultLayout/>}/>
            </Routes>
          </Suspense>
        </AuthProvider>
      </Router>
    )
  }
}

export default App
